const STORAGE_KEY = "affiliate_referrer";

const isBrowserEnvironment = () => typeof window !== "undefined" && typeof sessionStorage !== "undefined";

export const saveAffiliateReferrer = (affiliate) => {
    if (!affiliate || !isBrowserEnvironment()) {
        return;
    }

    try {
        sessionStorage.setItem(STORAGE_KEY, affiliate);
    } catch (error) {
        console.warn("Failed to persist affiliate referrer", error);
    }
};

export const getAffiliateReferrer = () => {
    if (!isBrowserEnvironment()) {
        return null;
    }

    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
        console.warn("Failed to read affiliate referrer", error);
        return null;
    }
};

export const clearAffiliateReferrer = () => {
    if (!isBrowserEnvironment()) {
        return;
    }

    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.warn("Failed to clear affiliate referrer", error);
    }
};


